import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';

import { ReferenceTableService } from '../reference-table.service';
import { ClientInformation, DataService, WpEtEnrollment } from '../shared';
import { NotificationsService } from 'angular2-notifications';
import { WpPerson, ServerConstantsService, CommonUtility } from '../shared';
import { NonComplianceRiskRecommendation } from '../shared/model/noncompliance-risk-recommendation.model';


@Component({
  selector: 'jhi-left-nav',
  templateUrl: './left-nav.component.html',
  styleUrls: ['left-nav.scss']
})

export class LeftNavComponent implements OnInit {
  wpPersonId: string = '';
  referralId: string = '';
  wpPerson: WpPerson;
  ssn;
  viewCreateTask = false;
  ServerConstants: any;
  userActionNotificationsMap: any;
  leftNavigationMap: any;
  sharedData: any;
  showPersonSummary = false;
  showContactSummary = false;
  showAppointment = false;
  showAssessmentSummary = false;
  showCaseNotesSummary = false;
  showEmploymentPlanSummary = false;
  showComponentsSummary = false;
  showNoncomplianceSummary = false;
  showParticipationSummary = false;
  showPaymentSummary = false;
  showReimbursementsSummary = false;
  isAnnouncement: boolean = true;
  emciId:Number = null;
  nonComplianceRisk: string = '';
  nonComplianceRiskRecommendation: NonComplianceRiskRecommendation;
  showCreateTask = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private commonUtil: CommonUtility,
    private refTableService: ReferenceTableService,
    private dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
  }

  ngOnInit() {
    if (this.router.url === '/task/componentSummary' || this.router.url === '/task/componentSummary/componentDetails'
    || this.router.url === '/task/componentSummary/serviceProvider' || this.router.url === '/task/componentSummary/trackComponent'
    || this.router.url === '/task/componentSummary/overallProgress' || this.router.url === '/task/componentSummary/auditHistory') {
     // Do Nothing
    } else {
      this.dataService.removeValueFromSharedDataMap('selectedEPForComponent');
    }

    if (this.router.url === '/task/announcementsSummary' || this.router.url === '/task/announcementsSummary/announcements') {
      this.isAnnouncement = false;
    }
    this.sharedData = this.dataService.getSharedDataObject();
    this.referralId = this.sharedData.get('referralId');
    this.wpPersonId = this.sharedData.get('wpPersonId');
    if(this.sharedData.get('personProvider') !== undefined && this.sharedData.get('personProvider') !== null){
      this.emciId = (this.sharedData.get('personProvider').emciId !== null && this.sharedData.get('personProvider').conversionStat === 'CM') ? parseInt(this.sharedData.get('personProvider').emciId) : null;
    }
    this.enableNavigation();

    //Retrieve reference tables
    this.refTableService.currentMessage.subscribe((message) => {
      //Parse reference table data
      if (message && message.englishDropDown) {
        this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(message.englishDropDown["USER-ACTION-NOTIFICATIONS"]);
        this.leftNavigationMap = message.englishDropDown["LEFT-NAVIGATION"];

        this.leftNavigationMap.forEach(element => {
          if (element.activeSW === "Y") {
            switch (element.name) {
              // case 'PersonSummary':this.showPersonSummary=true;break;
              // case 'ContactSummary':this.showContactSummary=true;break;
              // case 'Appointment':this.showAppointment=true;break;
              // case 'AssessmentSummary':this.showAssessmentSummary=true;break;
              // case 'NoncomplianceSummary':this.showNoncomplianceSummary=true;break;
              // case 'CaseNotesSummary':this.showCaseNotesSummary=true;break;
              // case 'EmploymentPlanSummary':this.showEmploymentPlanSummary=true;break;
              // case 'ComponentsSummary':this.showComponentsSummary=true;break;
              case 'ParticipationSummary': this.showParticipationSummary = true; break;
              case 'PaymentSummary': this.showPaymentSummary = true; break;
            }
          }

        });
      }
    });

    //Retrieve Person Data
    this.wpPerson = new WpPerson();   
    this.http.post<WpPerson>(this.ServerConstants.COMMON_SERVER_API_URL + '/persondata/load', parseInt(this.wpPersonId)).subscribe(
      (data: WpPerson) => {
        // convert date to the proper format for UI
        this.wpPerson = data;
        if (this.wpPerson.ssn !== undefined) {
          this.ssn = this.wpPerson.ssn.substring(5);
          this.dataService.addValueToSharedDataMap('SSN_SEARCH', this.wpPerson.ssn);
        }
        this.wpPerson.ssn = null;
        this.dataService.removeValueFromSharedDataMap("wpPerson");
        this.dataService.addValueToSharedDataMap("wpPerson", this.wpPerson);        
        this.dataService.removeValueFromSharedDataMap("personServiceCounty");
        this.dataService.addValueToSharedDataMap("personServiceCounty", this.wpPerson.serviceCounty);
      }, response => {
        //Display Toast Error Notification
        this.notificationService.error('Person', this.userActionNotificationsMap.ERROR);
      }, () => {
      });

    //Retrieve Non-Compliance Risk
    this.nonComplianceRiskRecommendation = new NonComplianceRiskRecommendation();
    this.http.post<NonComplianceRiskRecommendation>(this.ServerConstants.NC_SERVER_API_URL + '/ncsummary/risk', parseInt(this.wpPersonId)).subscribe(
      (data: NonComplianceRiskRecommendation) => {
        // convert date to the proper format for UI
        this.nonComplianceRiskRecommendation = data;
        console.log("Risk: " + this.nonComplianceRiskRecommendation);
        if (this.nonComplianceRiskRecommendation.risk !== undefined) {
          this.nonComplianceRisk = this.nonComplianceRiskRecommendation.risk;     
        } else {
          this.nonComplianceRisk = "";
        }      
      }, response => {       
        this.nonComplianceRisk = "";
      }, () => {
      });

    // this.http.post<WpEtEnrollment> (this.ServerConstants.SERVER_API_URL +
    //   "/assessment-summary/get-et-enrollment-by-person-refferal",
    //   {"referralId":parseInt(this.referralId),"personId": parseInt(this.wpPersonId)}  )
    //   .subscribe(
    //   (val) => {
    //     if(val!==undefined && val!==null)
    //     {
    //     this.dataService.addValueToSharedDataMap("etEnrollmentId", val.id);
    //     this.dataService.addValueToSharedDataMap("programCd", val.programCd);
    //     }
    //   },
    //   response => {
    //     this.notificationService.error('Dashboard', this.userActionNotificationsMap.ERROR);
    //   },
    //   () => {
    //   });

    /*this.http.get<ClientInformation[]>(this.ServerConstants.SERVER_API_URL + '/SNAPWorks/GetDemographic/' + this.wpPerson.ssn).subscribe(
      (data: ClientInformation[]) => {
        console.log(this.dataService.getSharedDataObject());
        console.log(this.wpPerson.ssn);
        if (data !== null && data !== undefined && data.length > 0) {         
          console.log('Snap Case is Open');
          this.viewCreateTask = true;
        } else {
          console.log('SNAP Case is closed');
          this.viewCreateTask = false;
        }
       
      },
      response => {
        this.enableNavigation();
      },
      () => {
        
      });*/

  }

  enableNavigation() {
    const CLINF = this.sharedData.get('CLINF');
    console.log("CLINF nav = " + CLINF['navigation']);
    if (undefined !== CLINF && CLINF['navigation']) {
      this.showPersonSummary = true;
    }

    const CNHIS = this.sharedData.get('CNHIS');
    console.log("CNHIS nav = " + CNHIS['navigation']);
    if (undefined !== CNHIS && CNHIS['navigation']) {
      this.showContactSummary = true;
    }

    const APPTS = this.sharedData.get('APPTS');
    console.log("APPTS nav = " + APPTS['navigation']);
    if (undefined !== APPTS && APPTS['navigation']) {
      this.showAppointment = true;
    }

    const NCMPL = this.sharedData.get('NCMPL');
    console.log("NCMPL nav = " + NCMPL['navigation']);
    if (undefined !== NCMPL && NCMPL['navigation']) {
      this.showNoncomplianceSummary = true;
    }

    const CSNTS = this.sharedData.get('CSNTS');
    console.log("case notes nav = " + CSNTS['navigation']);
    if (undefined !== CSNTS && CSNTS['navigation']) {
      this.showCaseNotesSummary = true;
    }

    const EMPPL = this.sharedData.get('EMPPL');
    console.log("Employment plan nav = " + EMPPL['navigation']);
    if (undefined !== EMPPL && EMPPL['navigation']) {
      this.showEmploymentPlanSummary = true;
    }
    
    const COMPS = this.sharedData.get('COMPS');
    console.log("Components nav = " + COMPS['navigation']);
    if (undefined !== COMPS && COMPS['navigation']) {
      this.showComponentsSummary = true;
    }

    const RIMBS = this.sharedData.get('RIMBS');
    console.log("Reimbursements nav = " + RIMBS['navigation']);
    if (undefined !== RIMBS && RIMBS['navigation']) {
      this.showReimbursementsSummary = true;
    }

    const ASMNT = this.sharedData.get('ASMNT');
    console.log("AssessmentSummary = " + ASMNT['navigation']);
    if (undefined !== ASMNT && ASMNT['navigation']) {
      this.showAssessmentSummary = true;
    }

    const CRTSK = this.sharedData.get('CRTSK');
    console.log("Create Task nav = " + CRTSK['navigation']);
    if (undefined !== CRTSK && CRTSK['navigation']) {
      this.showCreateTask = true;
    }

  }
  
}



// WEBPACK FOOTER //
// ./src/app/left-nav/left-nav.component.ts